// @flow
import React from 'react';
import type { Node } from 'react';

// The viewer's own line icons, drawn alike (24 grid, 2px stroke): the sprite's are filled and mixed in weight
const Glyph = ({ children, size = 22 }: { children: Node, size?: number }) => (
  <svg
    className="pdfGlyph"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
);

export const Close = () => <Glyph><path d="M6 6l12 12M18 6L6 18" /></Glyph>;
export const Minus = () => <Glyph><path d="M5 12h14" /></Glyph>;
export const Plus = () => <Glyph><path d="M12 5v14M5 12h14" /></Glyph>;
export const FitWidth = () => <Glyph><path d="M4 5v14M20 5v14M8 12h8M10.5 9.5L8 12l2.5 2.5M13.5 9.5L16 12l-2.5 2.5" /></Glyph>;
export const Download = () => <Glyph><path d="M12 4v11M7.5 10.5L12 15l4.5-4.5M5 20h14" /></Glyph>;
export const ShareIos = () => <Glyph><path d="M12 3v12M8 7l4-4 4 4M8 11H6v10h12V11h-2" /></Glyph>;
export const ShareAndroid = () => (
  <Glyph>
    <circle cx="18" cy="5" r="2.5" />
    <circle cx="6" cy="12" r="2.5" />
    <circle cx="18" cy="19" r="2.5" />
    <path d="M8.2 10.8l7.6-4.4M8.2 13.2l7.6 4.4" />
  </Glyph>
);
export const ChevronLeft = ({ size }: { size?: number }) => <Glyph size={size}><path d="M15 5l-7 7 7 7" /></Glyph>;
export const ChevronRight = ({ size }: { size?: number }) => <Glyph size={size}><path d="M9 5l7 7-7 7" /></Glyph>;
export const File = () => (
  <Glyph size={20}>
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
    <path d="M14 3v5h5M9 13h6M9 17h4" />
  </Glyph>
);
export const Alert = () => (
  <Glyph size={40}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7.5v5.5M12 16.5v.01" />
  </Glyph>
);
